module.exports = __webpack_public_path__ + "img/5.a1ab4ef2.jpg";